import {IRuleset, ISystem, ISystemRole} from "../../index";
import {ErrorObject} from "../../error/ErrorObject";
import {Tab} from "../tab-list/Tab";
import {ErrorManager} from "../../error/ErrorManager";

interface ISystemMutable {
    // meta
    errName: ErrorObject
    errDescription: ErrorObject
    errSystemOwner: ErrorObject
    isSystemMegaEadm: boolean

    // system data
    availableto: KnockoutObservable<IRuleset | null>
    description: KnockoutObservable<string>,
    managedby: KnockoutObservable<IRuleset | null>
    multiplerolesamecompany: KnockoutObservable<boolean>
    multiplerolesamedepartment: KnockoutObservable<boolean>
    name: KnockoutObservable<string>
    prioritybasedroles: KnockoutObservable<boolean>
    purgemanualdepartmentpermissions: KnockoutObservable<boolean>
    roles: KnockoutObservableArray<ISystemRoleMutable>
    systemowner: KnockoutObservable<string>
}

interface ISystemRoleMutable {
    // meta
    $original: ISystemRole
    errName: ErrorObject
    errRoleEnum: ErrorObject
    errPriority: ErrorObject
    errSystemOwner: ErrorObject

    // system role data
    availableto_id: KnockoutObservable<number>
    availabletorulesets: KnockoutObservableArray<KnockoutObservable<number>>
    description: KnockoutObservable<string>
    id: number
    memberofgroup: KnockoutObservable<number>
    memberofgroups: KnockoutObservableArray<KnockoutObservable<number>>
    metadata: KnockoutObservable<string>
    name: KnockoutObservable<string>
    priority: KnockoutObservable<number>
    purgemanualdepartmentpermissions: KnockoutObservable<boolean>
    recursive: KnockoutObservable<boolean>
    roleenum: KnockoutObservable<number>
    rolememberruleset: KnockoutObservable<number>
    rolememberrulesets: KnockoutObservableArray<KnockoutObservable<number>>
    systemowner: KnockoutObservable<string>
}

type TTabId = 'systemaccessinfo' | 'systemaccessroles'

type TTabs = {
    [Property in TTabId]: Tab
}

type TErrorManagers = {
    [Property in TTabId]: ErrorManager
}

type IIsSystemPropertyMutable = {
    [K in keyof ISystem]: boolean
}

type IIsRolePropertyMutable = {
    [K in keyof ISystemRole]: boolean
}